import styled from 'styled-components'

const Container = styled.div`
  height: 50px;
  text-align: left;
  margin-top: 30px;
`

const Footer = () => {
    return (
        <footer>
            <Container>
                <hr/>
                {/* КИП-Юг © 2013-2024 */}
            </Container>
        </footer>
    );
}

export default Footer;
